import Specialities from './Specialities'
export default Specialities
